<template>
  <div class="flex flex-col w-full gap-3">
    <div class="flex w-full justify-between items-center" v-if="message || infoTop">
      <label v-if="message" :for="computedLabelId" class="textarea-info-message">{{
        message
      }}</label>
      <span v-if="infoTop" class="textarea-info-text-top">{{ infoTop }}</span>
    </div>
    <TextArea
      unstyled
      :id="computedLabelId"
      :name="name"
      :placeholder="placeholder"
      :autoResize="autoResize"
      :disabled="disabled"
      :rows="rows"
      :cols="cols"
      v-model="localModelValue"
      @blur="$emit('blur')"
      :class="[
        wrapperClass,
        'textarea-primary',
        {
          'textarea-disabled': disabled,
        },
      ]"
    />
    <span v-if="infoBottom" class="textarea-info-text-bottom">{{ infoBottom }}</span>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed, defineEmits } from "vue";
import TextArea from "primevue/textarea";
const emit = defineEmits(["update:modelValue", "blur"]);
const props = defineProps({
  modelValue: null,
  placeholder: {
    type: String,
    default: "Tap to type",
  },
  message: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  infoTop: {
    type: String,
    default: "",
  },
  infoBottom: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: String,
    default: "5",
  },
  cols: {
    type: String,
    default: "",
  },
  autoResize: {
    type: Boolean,
    default: true,
  },
  wrapperClass: {
    type: String,
    default: "",
  },
});
const localModelValue = computed({
  get: () => props.modelValue,
  set: value => emit("update:modelValue", value),
});
const computedLabelId = computed(() => props.id);
</script>
